import './index.scss';
import React, { PropTypes }  from 'react';
import { Link } from 'react-router';
import _ from 'underscore';

const NotificationAction = React.createClass({
    propTypes: {
        action: PropTypes.object.isRequired,
        dismiss: PropTypes.func.isRequired
    },
    renderExternalLinkAction: function(name, externalLink) {
        return (
            <span className="notification-action"><h4><a href={externalLink} target="_blank">{name}</a></h4></span>
        );
    },
    renderDismissAction: function(name, dismiss) {
        return (
            <span className="notification-action"><h4><Link to="#" onClick={dismiss}>{name}</Link></h4></span>
        );
    },
    render: function () {
        const { action, dismiss } = this.props;

        if (action.externalLink) { return this.renderExternalLinkAction(action.name, action.externalLink); }
        if (action.dismiss) { return this.renderDismissAction(action.name, dismiss); }
    }
});

export default NotificationAction;



// WEBPACK FOOTER //
// ./src/components/common/NotificationAction/index.jsx